import { render, staticRenderFns } from "./CanvasPointer.vue?vue&type=template&id=a9049f3e&"
import script from "./CanvasPointer.vue?vue&type=script&lang=ts&"
export * from "./CanvasPointer.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasPointer.vue?vue&type=style&index=0&id=a9049f3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports